<template>
  <v-card-text>
    <div class="d-flex align-center ga-2 mb-4 flex-wrap">
      <div class="label mb-0">Завдання № {{ task.id }}</div>
      <v-chip color="blue-darken-3" rounded="pill" size="small" variant="tonal">
        <span class="font-weight-bold font-size-13">
          {{ task.status?.name }}
        </span>
      </v-chip>
      <v-chip
        v-if="task.isCEO"
        color="warning"
        rounded="pill"
        size="small"
        variant="tonal">
        <div class="d-flex align-center ga-1">
          <v-icon size="small">mdi-star-outline</v-icon>
          <span class="font-weight-bold font-size-13">Від ГД</span>
        </div>
      </v-chip>
      <v-chip
        v-if="task.isHighImportance"
        color="error"
        rounded="pill"
        size="small"
        variant="tonal">
        <div class="d-flex align-center ga-1">
          <v-icon size="small">mdi-alert-outline</v-icon>
          <span class="font-weight-bold font-size-13">Важлива</span>
        </div>
      </v-chip>
      <v-chip
        v-if="isDeadlineClose && [1, 2].includes(task.statusId)"
        color="error"
        rounded="pill"
        size="small"
        variant="tonal">
        <div class="d-flex align-center ga-1">
          <v-icon size="small">mdi-clipboard-text-clock-outline</v-icon>
          <span class="font-weight-bold font-size-13"> {{ deadlineText }}</span>
        </div>
      </v-chip>
    </div>

    <v-card border style="background: #fafbfc">
      <v-card-text class="d-flex align-center ga-4 flex-wrap">
        <v-switch
          v-model="task.isCEO"
          :readonly="disabled"
          color="blue-darken-3"
          density="compact"
          hide-details
          inset>
          <template #label>
            <span
              :class="
                task.isCEO ? 'font-weight-bold text-black' : 'text-disabled'
              "
              class="font-size-13">
              Завдання від ГД
            </span>
          </template>
        </v-switch>
        <v-switch
          v-if="!taskType.familiarization"
          v-model="task.isHighImportance"
          :readonly="disabled"
          color="error"
          density="compact"
          hide-details
          inset>
          <template #label>
            <span
              :class="
                task.isHighImportance
                  ? 'font-weight-bold text-black'
                  : 'text-disabled'
              "
              class="font-size-13">
              Важливе завдання
            </span>
          </template>
        </v-switch>
      </v-card-text>
    </v-card>
  </v-card-text>
</template>

<script lang="ts">
import { computed, inject } from 'vue'
import { CustomDate } from 'best-modules/utils'

export default {
  name: 'TaskHeader',
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ['update:model-value'],
  setup(props, { emit }) {
    const task = computed({
      get() {
        return props.modelValue
      },
      set(v) {
        emit('update:model-value', v)
      },
    })
    const taskType = inject(
      'taskType',
      computed(() => ({
        execution: false,
        familiarization: false,
        errand: false,
      }))
    )

    const now = computed(() => new Date())

    const deadlineDate = computed(() => {
      if (!task.value?.deadline) return null

      return new CustomDate(task.value.deadline).date.toDate()
    })

    const isOverdue = computed(() => {
      if (!deadlineDate.value) return false
      return deadlineDate.value.getTime() < now.value.getTime()
    })

    const isDeadlineClose = computed(() => {
      if (!deadlineDate.value) return false

      const timeDiff = deadlineDate.value.getTime() - now.value.getTime()

      return isOverdue.value || timeDiff <= 24 * 60 * 60 * 1000
    })

    const deadlineText = computed(() => {
      if (!deadlineDate.value) return ''

      if (isOverdue.value) {
        return 'Прострочено'
      }

      return new CustomDate(deadlineDate.value).toString({
        time: true,
        format: 'locale-hybrid',
      })
    })

    return {
      task,
      isDeadlineClose,
      deadlineText,
      taskType,
    }
  },
}
</script>
